// -*- mode: rjsx -*-
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { List } from "./List.jsx";

import { selectMentorRequests, loadMentor } from '../../queue';

function UnclaimedMentorList(props) {
    
    const dispatch = useDispatch();

    const tasks = useSelector(selectMentorRequests);

    function _load(dispatch, cursor) {
        dispatch(loadMentor(cursor)).then((data) => {
            if(data.type == "queue/loadMentor/fulfilled") {
                if(data.payload.next_page) {
                    _load(dispatch, data.payload.next_page);
               }
        }
    });
}
	useEffect(() => {
		_load(dispatch, "");
    }, [dispatch]);


	return <List tasks={tasks} queue={props.queue} />;
}

export { UnclaimedMentorList };


